




















































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { UserStore, RoleStore } from "@/store";
import {
  ConfirmTermsAndServiceCommand,
  UserDto,
  UserType
} from "@/api/AuthenticationApiClient";

@Component
export default class TermsConditions extends Vue {
  private checked: boolean = false;
  private user!: UserDto;

  public async onClickConfirm(event: MouseEvent) {
    event.preventDefault();

    this.user = await UserStore.ConfirmTerms(
      new ConfirmTermsAndServiceCommand({
        username: UserStore.getUserName,
        terms: true
      })
    );

    const result = await UserStore.Confirm(this.user);
  }
}
